$(function(){

    // Label the color actually selected (the page can open on ?variant=, e.g. from the Closeouts page band);
    // the first swatch only when none is checked.
    var $startSwatch = $(".salba-color-swatches input:checked").next(".color-swatch");
    if (!$startSwatch.length) { $startSwatch = $(".salba-color-swatches").find(".color-swatch:first"); }
    setColorPickerLabel($startSwatch.data("option"));

    function setActiveSwatchSlider(mediaId, prepend){
        // update main slider
        $("[data-media-id]").removeClass("is-active");
        $(`[data-media-id="${ mediaId }"]`).addClass("is-active").prependTo(".product__media-list.slider");
        // update thumbnail slider
        $(".thumbnail-list.slider [data-target] button").removeAttr("aria-current");
        $(`.thumbnail-list.slider [data-target="${ mediaId }"]`).prependTo(".thumbnail-list.slider");
        $(`.thumbnail-list.slider [data-target="${ mediaId }"] button`).attr("aria-current", "true");
    }

    function setColorPickerLabel(name){
        if(name !== undefined){
            var labelEl = $(".salba-color-picker-label-name").get(0);
            if(labelEl){ labelEl.innerHTML = name; }
            // Closeout colors (snippet rc-closeout-colors → data-closeout): CLOSEOUT tag + "No restock" for the color shown.
            var closeout = $(".salba-color-swatches input[data-closeout='true']").filter(function(){
                return $(this).next(".color-swatch").data("option") == name;
            }).length > 0;
            $(".salba-color-swatches .rc-co-tag, .salba-color-swatches .rc-co-why").prop("hidden", !closeout);
            $(".salba-color-swatches .rc-co-key").prop("hidden", closeout);
            // The CLOSEOUT badge on the product photo (dynamic-badge STEP 3) follows the color too.
            $("[data-rc-co-badge]").prop("hidden", !closeout);
        }
    }

    function setVariantParameter(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
        console.log(variantId);
    }
    
    $(".salba-color-swatches").find("input").each(function(index,swatch){
        $(swatch).on("click", function(){
            if ($(this).next(".color-swatch").hasClass("no_featured_media")) return;
            let media_id = $(this).next(".color-swatch").data("swatch-media-id");
            let name = $(this).next(".color-swatch").data("option");
            setColorPickerLabel(name);        
            setActiveSwatchSlider(media_id);
            setVariantParameter($(this).data("variant-id"));
        });      
    })
});